import React from 'react';
import {
  IResourceComponentsProps,
  BaseRecord,
  useTranslate,
  CrudFilters,
} from '@refinedev/core';
import {
  useTable,
  List,
  EditButton,
  ShowButton,
  BooleanField,
  DateField,
  ImageField,
  useSelect,
} from '@refinedev/antd';
import {
  Table,
  Space,
  Collapse,
  Button,
  Form,
  FormProps,
  Input,
  Select,
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const { Panel } = Collapse;

export const EarnCampaignList: React.FC<IResourceComponentsProps> = () => {
  const translate = useTranslate();
  const { tableProps, searchFormProps } = useTable({
    syncWithLocation: true,
    onSearch: (params: any) => {
      let filters: CrudFilters = [];
      const { search, earnNetworkId } = params;

      filters = [
        {
          field: 'search',
          operator: 'eq',
          value: search,
        },
        {
          field: 'earnNetworkId',
          operator: 'eq',
          value: earnNetworkId,
        },
      ];

      return filters;
    },
  });

  return (
    <>
      <Collapse defaultActiveKey={['0']} style={{ marginBottom: 16 }}>
        <Panel header="Filter" key="1">
          <Filter formProps={searchFormProps} />
        </Panel>
      </Collapse>
      <List>
        <Table {...tableProps} rowKey="id">
          <Table.Column dataIndex="name" title="Name" />

          <Table.Column dataIndex="earnNetworkName" title="Earn Network" />

          <Table.Column
            dataIndex="icon"
            title="Icon"
            render={(value: any) => (
              <ImageField style={{ maxWidth: 150 }} value={value} />
            )}
          />
          <Table.Column dataIndex="type" title="Type" />

          <Table.Column dataIndex="platform" title="Platform" />

          <Table.Column
            dataIndex={['isSlide']}
            title="Is Slide"
            render={(value: any) => <BooleanField value={value} />}
          />
          <Table.Column
            dataIndex={['isActive']}
            title="Is Active"
            render={(value: any) => <BooleanField value={value} />}
          />
          <Table.Column
            dataIndex={['startDate']}
            title="Start Date"
            render={(value: any) => <DateField value={value} />}
          />
          <Table.Column
            dataIndex={['endDate']}
            title="End Date"
            render={(value: any) => <DateField value={value} />}
          />
          <Table.Column
            title={translate('table.actions')}
            dataIndex="actions"
            render={(_, record: BaseRecord) => (
              <Space>
                <EditButton hideText size="small" recordItemId={record.id} />
                <ShowButton hideText size="small" recordItemId={record.id} />
              </Space>
            )}
          />
        </Table>
      </List>
    </>
  );
};

const Filter: React.FC<{ formProps: FormProps }> = ({ formProps }) => {
  const { selectProps: earnNetworkSelectProps } = useSelect({
    resource: 'earn-network',
    optionLabel: 'name',
    pagination: {
      pageSize: 100,
      mode: 'server',
    },
  });
  return (
    <Form layout="vertical" {...formProps}>
      <Form.Item label="Search" name="search">
        <Input placeholder="Search name" prefix={<SearchOutlined />} />
      </Form.Item>
      <Form.Item label="Earn Network" name="earnNetworkId">
        <Select {...earnNetworkSelectProps} />
      </Form.Item>
      <Form.Item>
        <Button htmlType="submit" type="primary">
          Filter
        </Button>
      </Form.Item>
    </Form>
  );
};
